import {axios} from "../../../lib";

export const sendDocumentToOMC = async (documentId) => {
    return await axios.put(`/documents/${documentId}/status/send-to-omc`);
};
